import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import './SelectWorker.css';
import Role from './selectoptions/Role';

const fetchWorkLogUsers = async (token) => {
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const response = await fetch(`${apiUrl}/auth/worklog-users`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return response.json();
};

export default function SelectWorker({
  workers,
  setWorkers,
  setTotalExpense,
  closeShowWorkLogModal,
}) {
  const token = localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(true);
  const [selectedWorker, setSelectedWorker] = useState(null);

  const { data: workLogUsers } = useQuery(
    ['workLogUsers'],
    () => fetchWorkLogUsers(token),
    {
      onSuccess: () => {
        setIsLoading(false);
      },
      enabled: true,
    }
  );

  const [workerTime, setWorkerTime] = useState();

  const handleWorkerAddition = () => {
    setWorkers((prevState) => {
      return [
        ...prevState,
        {
          user: workLogUsers[selectedWorker],
          currentHourlyRate: parseFloat(
            workLogUsers[selectedWorker].hourlyRate
          ),
          minutes: parseInt(workerTime),
        },
      ];
    });

    setTotalExpense(
      (prevTotal) =>
        prevTotal +
        parseFloat((workLogUsers[selectedWorker].hourlyRate / 60) * workerTime)
    );

    closeShowWorkLogModal();
  };

  return (
    <div>
      {isLoading ? (
        <div className="select-worker-spinner">
          <ClipLoader
            color={'gray'}
            loading={isLoading}
            size={60}
            data-testid="loader"
          />
        </div>
      ) : (
        <>
          <div>
            <h3 className="add-worker-label">Odaberi radnika</h3>

            <div className="choose-worker">
              <div className="worker-list">
                {workLogUsers.map((item, index) => (
                  <div
                    className={
                      workers.some((worker) => worker.user.id === item.id)
                        ? 'worker-information worker-information-disabled'
                        : selectedWorker === index
                        ? 'worker-information worker-information-transition active-worker'
                        : 'worker-information worker-information-transition'
                    }
                    key={index}
                    onClick={() =>
                      workers.some((worker) => worker.user.id === item.id)
                        ? () => {}
                        : setSelectedWorker(index)
                    }
                  >
                    <div
                      className="worker-initials"
                      style={{
                        backgroundColor: workers.some(
                          (worker) => worker.user.id === item.id
                        )
                          ? 'gray'
                          : '#1a79cb',
                      }}
                    >
                      {item.firstName[0]}
                      {item.lastName[0]}
                    </div>

                    <div>
                      <div className="worker-name">
                        {item.firstName} {item.lastName}
                      </div>
                      <div className="worker-position">
                        {
                          Object.values(Role).find(
                            (role) => role.value === item.role
                          ).label
                        }
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="worker-work-time-container">
            <div className="worker-work-time">
              <h3 className="add-worker-label">Vrijeme rada (min)</h3>
              <input
                className="worker-time-input"
                type="number"
                placeholder="0"
                value={workerTime}
                onChange={(e) => setWorkerTime(e.target.value)}
              />
            </div>

            <button
              className="add-worker-button"
              type="button"
              onClick={handleWorkerAddition}
              disabled={
                selectedWorker === null ||
                workerTime <= 0 ||
                workerTime === undefined
              }
            >
              Dodaj radnika
            </button>
          </div>
        </>
      )}
    </div>
  );
}
